import { PIcon } from '@porsche-design-system/components-react';
import DatePicker, { type DatePickerFieldProps } from '../../../components/fields/DatePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import { DatePickerContainer } from './shared';

const DatePickerField = ({ className, ...props }: DatePickerFieldProps) => (
    <DatePickerContainer disabled={props.disabled}>
        <DatePicker
            {...props}
            errorIcon={
                <PIcon aria={{ 'aria-label': 'Exclamation icon' }} color="notification-error" name="exclamation" />
            }
            suffixIcon={<CalendarIcon />}
        />
    </DatePickerContainer>
);

export default DatePickerField;
